import { Card } from "../../../components/ui/card";
import { Button } from "../../../components/ui/button";
import { Badge } from "../../../components/ui/badge";
import { ChevronDown } from "lucide-react";
import { useState } from "react";

export const ReportContentsSection = () => {
  const [showMore, setShowMore] = useState(false);

  const reportContents = [
    { number: "01", title: "Lagan aur Rashi Report", description: "" },
    { number: "02", title: "Nakshatra Report", description: "" },
    { number: "03", title: "Panchang Phal", description: "" },
    { number: "04", title: "Future Aspects", description: "" },
    { number: "05", title: "Planets Prediction", description: "" },
    { number: "06", title: "Raj Yogas", description: "" },
    { number: "07", title: "Mangal Report", description: "" },
    { number: "08", title: "Saade Saati Report", description: "" },
    { number: "09", title: "Kaalsarp Dosha & remedies", description: "" },
    { number: "10", title: "Complete Dasha Predictions", description: "" },
    { number: "11", title: "Rudraksh & Gemstones Recommendation", description: "" },
    { number: "12", title: "Auspicious Timings of Career & business", description: "" },
    { number: "13", title: "Shodash varga", description: "" },
    { number: "14", title: "Shadbal & Astakvarg", description: "" },
    { number: "15", title: "KP Cusp Report", description: "" },
    { number: "16", title: "Yogini & Char Dasha", description: "" },
    { number: "17", title: "Tajik Varshphal - 5 years", description: "" },
    { number: "18", title: "Atimitra Nakshatra Details", description: "" },
  ];

  const visibleContents = showMore ? reportContents : reportContents.slice(0, 3);

  return (
    <section className="bg-gradient-to-b from-cosmic-blue/10 to-background-blue">
      <div className="container mx-auto px-6">
        {/* Section Title */}
        <div className="text-center mb-16 pt-8">
          <h2 className="text-4xl lg:text-5xl font-bold text-foreground">
            This is what you get in the Report
          </h2>
        </div>

        {/* Report Contents Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {visibleContents.map((item, index) => (
            <Card key={index} className="p-6 border-cosmic-gold/20 bg-card-blue/50 backdrop-blur-sm hover:shadow-[0_0_20px_hsl(var(--mystic-gold)/0.2)] transition-all duration-300">
              <div className="flex items-start space-x-4">
                {/* Number Badge */}
                <Badge className="bg-gradient-to-b from-cosmic-gold to-cosmic-gold-dark text-primary-foreground font-bold text-lg px-3 py-1 rounded-full flex-shrink-0">
                  {item.number}
                </Badge>
                
                {/* Content */}
                <div>
                  <h3 className="text-lg font-semibold text-foreground mb-2">
                    {item.title}
                  </h3>
                  <p className="text-muted-foreground text-sm">
                    {item.description}
                  </p>
                </div>
              </div>
            </Card>
          ))}
        </div>

        {/* Show More Button */}
        {!showMore && (
          <div className="text-center">
            <Button 
              variant="cosmic-outline" 
              onClick={() => setShowMore(true)}
              className="group"
            >
              Show More
              <ChevronDown className="w-4 h-4 ml-2 group-hover:translate-y-1 transition-transform" />
            </Button>
          </div>
        )}
      </div>
    </section>
  );
};